import { DestroyRef, inject } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { filter, Subscription, take } from 'rxjs';
import { ErrorKeys } from '../../components/error-messages/error-messages.component';

export const ConfirmPassword = (
  referenceControl: AbstractControl,
  destroyRef?: DestroyRef
): ValidatorFn => {
  let subscription: Subscription | null = null;

  destroyRef = destroyRef ?? inject(DestroyRef);

  destroyRef.onDestroy(() => subscription?.unsubscribe());
  return (control: AbstractControl) => {
    subscription =
      subscription ??
      referenceControl.valueChanges.subscribe(() => {
        control.updateValueAndValidity();
      });

    return control.value === referenceControl.value ? null : { [ErrorKeys.Confirm]: false };
  };
};

export const BackendValidationError = (errorKey: ErrorKeys): ValidatorFn => {
  const functionRef: ValidatorFn = (control) => {
    const originalValue = control.value;
    control.valueChanges
      .pipe(
        filter((value) => value !== originalValue),
        take(1)
      )
      .subscribe({
        next: () => {
          control.removeValidators([functionRef]);
          control.updateValueAndValidity();
        },
      });
    return {
      [errorKey]: true,
    };
  };
  return functionRef;
};

export function RequiredIf<ReferenceControlValue = unknown>(
  referenceControl: AbstractControl<ReferenceControlValue>,
  requiredCondition: (value: ReferenceControlValue) => boolean,
  destroyRef?: DestroyRef
): ValidatorFn {
  destroyRef ??= inject(DestroyRef);

  let subscription: Subscription | null = null;

  destroyRef.onDestroy(() => subscription?.unsubscribe());

  return (control: AbstractControl) => {
    subscription ??= referenceControl.valueChanges.subscribe({
      next: () => control.updateValueAndValidity(),
    });

    return requiredCondition(referenceControl.value) && !control.value
      ? { [ErrorKeys.RequiredIf]: true }
      : null;
  };
}
